import { render, staticRenderFns } from "./ModalAdicionarEventoAgenda.vue?vue&type=template&id=0b47e56c&scoped=true"
import script from "./ModalAdicionarEventoAgenda.vue?vue&type=script&lang=js"
export * from "./ModalAdicionarEventoAgenda.vue?vue&type=script&lang=js"
import style0 from "./ModalAdicionarEventoAgenda.vue?vue&type=style&index=0&id=0b47e56c&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b47e56c",
  null
  
)

export default component.exports